import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for headings. `lines` = array of strings/nodes.
export const MaskedLines = ({ lines, className = "", lineClassName = "", start = false, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={start ? { y: "0%" } : {}}
          whileInView={start ? undefined : { y: "0%" }}
          viewport={start ? undefined : { once: true }}
          transition={{ duration: 1, ease, delay: 0.2 + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Overline = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-10 bg-[#e7c15a]" />
    <span className="text-xs md:text-sm uppercase tracking-[0.28em] text-[#e7c15a]">{children}</span>
  </div>
);
